var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreYouDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 90,
    viewBox: "0 0 75 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 49"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3431 70.453C39.3056 70.5581 39.2699 70.7068 39.2425 70.8813C39.2926 70.7131 39.3275 70.5663 39.3431 70.453ZM35.3455 72.8147C35.241 73.0319 35.1655 73.727 35.2929 74.3452C35.4997 73.667 35.542 73.0803 35.3455 72.8147ZM37.7633 73.3406C37.8274 73.5332 37.885 73.5703 37.8856 73.5707C38.1155 73.3743 38.3787 72.9484 38.618 72.4636C38.4225 72.4562 38.202 72.4552 37.9619 72.4614C37.9288 72.7348 37.8593 73.037 37.7633 73.3406ZM35.5193 74.951C35.6073 75.0845 35.7254 75.1891 35.8817 75.1962C36.1934 75.2092 36.5686 74.879 36.9086 74.2872C37.0857 73.9787 37.2272 73.6494 37.3335 73.3334C37.2651 73.0767 37.2297 72.777 37.2178 72.5013C36.7612 72.5377 36.2634 72.5991 35.7509 72.6912C36.018 73.208 35.8633 74.0812 35.5193 74.951ZM31.7311 74.2796C31.9473 75.7154 32.6707 76.7701 33.2844 76.9607C33.5724 77.0501 33.8375 76.9485 34.0721 76.6604C34.4719 76.1702 34.8166 75.5652 35.064 74.9755C34.993 74.823 34.9354 74.6443 34.8927 74.4413C34.7934 73.968 34.7772 73.3186 34.8946 72.8731C34.2317 73.0358 33.5675 73.2558 32.9522 73.5449C32.4811 73.7664 32.0736 74.0115 31.7311 74.2796ZM36.2701 78.7208C34.8986 79.1624 33.5603 79.393 32.5083 79.3059C30.9044 79.173 30.0014 78.3382 29.9656 76.9545C29.9369 75.8569 30.3958 74.8954 31.2944 74.1159C31.2858 74.0411 31.2786 73.9662 31.273 73.891C31.214 73.117 31.3802 72.6026 31.7674 72.3626C32.3938 71.9748 33.3239 72.5054 33.3632 72.5281L33.1552 72.8816C32.9467 72.7611 32.3274 72.4958 31.9849 72.71C31.6897 72.8938 31.6541 73.4003 31.6801 73.8117C32.4115 73.286 33.3668 72.8563 34.5316 72.5438C35.3925 72.3114 36.3514 72.1576 37.2182 72.0876C37.2229 71.9912 37.2309 71.9049 37.2414 71.8346C37.2697 71.6446 37.3362 71.4223 37.524 71.3778C37.5953 71.3621 37.7334 71.3639 37.8563 71.5504C37.935 71.6699 37.975 71.8418 37.9826 72.0474C38.2811 72.0407 38.5585 72.0461 38.8042 72.0639C38.8064 72.0586 38.8086 72.0535 38.811 72.0482C38.7511 71.5631 38.7932 70.9919 38.8744 70.6229C38.9786 70.149 39.1497 69.9094 39.3896 69.8862C39.5336 69.8732 39.6587 69.9499 39.7161 70.0868C39.8504 70.408 39.5988 71.2762 39.2344 72.109C39.2346 72.1104 39.2348 72.112 39.2353 72.1136C39.5768 72.1708 39.8086 72.2647 39.8816 72.3962C39.9366 72.4947 39.9435 72.6473 39.7985 72.78C39.5228 73.0324 39.3026 72.9691 39.196 72.9085C39.106 72.8571 39.0333 72.7699 38.9754 72.6574C38.6996 73.1991 38.3995 73.6624 38.1635 73.8586C37.9463 74.0402 37.7556 73.9674 37.6841 73.9277C37.6469 73.9069 37.6121 73.8789 37.5799 73.845C37.486 74.0724 37.38 74.2918 37.2662 74.49C36.8354 75.2416 36.3501 75.6283 35.8627 75.6051C35.6632 75.5959 35.4865 75.517 35.3371 75.3738C35.0676 75.9538 34.7286 76.5055 34.3924 76.918C34.0497 77.3375 33.6132 77.4915 33.1619 77.3514C32.3628 77.1034 31.6401 75.9547 31.3693 74.5937C30.6865 75.2572 30.3541 76.0432 30.3772 76.9441C30.408 78.1243 31.1365 78.7816 32.5423 78.8981C36.0907 79.1916 42.3128 75.9134 42.7844 73.5012C42.4009 75.4626 39.4485 77.6974 36.2701 78.7208Z",
    fill: "#4C458E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_14580",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 90
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 90H75V0H0V90Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_14580)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.736604 17.472H14.9023V3.396H0.736604V17.472ZM0 18.2039H15.6388V2.66406H0V18.2039Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20805 15.0809C7.88012 15.0809 7.56736 14.9358 7.35653 14.6825L2.53067 8.88163C2.14188 8.4142 2.20797 7.7222 2.67829 7.33587C3.14843 6.94954 3.84493 7.01512 4.23381 7.48255L8.06113 12.0831L14.9848 0.536042C15.2972 0.0150708 15.9753 -0.155352 16.4995 0.154822C17.0238 0.46517 17.1955 1.13897 16.8832 1.65995L9.15732 14.5448C8.97343 14.8516 8.65108 15.0502 8.2928 15.0776C8.26446 15.0798 8.23621 15.0809 8.20805 15.0809Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.736604 41.7699H14.9023V27.6939H0.736604V41.7699ZM0 42.5018H15.6388V26.9619H0V42.5018Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20805 39.2449C7.88012 39.2449 7.56736 39.0999 7.35653 38.8466L2.53067 33.0456C2.14188 32.5784 2.20797 31.8863 2.67829 31.5C3.14843 31.1136 3.84493 31.1792 4.23381 31.6467L8.06113 36.2471L14.9848 24.7001C15.2972 24.1791 15.9753 24.0087 16.4995 24.3189C17.0238 24.6293 17.1955 25.3031 16.8832 25.824L9.15732 38.7089C8.97343 39.0157 8.65108 39.2143 8.2928 39.2416C8.26446 39.2439 8.23621 39.2449 8.20805 39.2449Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.736604 65.5648H14.9023V51.4887H0.736604V65.5648ZM0 66.2966H15.6388V50.7568H0V66.2966Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20805 62.8104C7.88012 62.8104 7.56736 62.6653 7.35653 62.412L2.53067 56.6111C2.14188 56.1437 2.20797 55.4517 2.67829 55.0654C3.14843 54.679 3.84493 54.7446 4.23381 55.2121L8.06113 59.8126L14.9848 48.2655C15.2972 47.7445 15.9753 47.5742 16.4995 47.8843C17.0238 48.1947 17.1955 48.8685 16.8832 49.3895L9.15732 62.2743C8.97343 62.5811 8.65108 62.7797 8.2928 62.8071C8.26446 62.8093 8.23621 62.8104 8.20805 62.8104Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 7.80617H46.5706V6.29004H26.1782V7.80617Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2632 7.80617H63.8981V6.29004H59.2632V7.80617Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 14.5777H46.5706V13.0615H26.1782V14.5777Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9883 14.5777H63.8982V13.0615H56.9883V14.5777Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2183 11.1919H63.898V9.67578H58.2183V11.1919Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2441 11.1919H46.9239V9.67578H41.2441V11.1919Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 11.1919H38.7982V9.67578H26.1782V11.1919Z",
    fill: "#4C458E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 31.1431H45.7922V29.627H26.1782V31.1431Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 37.9146H46.5706V36.3984H26.1782V37.9146Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2607 34.5288H45.5382V33.0127H40.2607V34.5288Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 34.5288H38.7982V33.0127H26.1782V34.5288Z",
    fill: "#4C458E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 55.1411H46.5706V53.625H26.1782V55.1411Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 61.9126H46.5706V60.3965H26.1782V61.9126Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2607 58.5269H49.1292V57.0107H40.2607V58.5269Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1782 58.5269H38.7982V57.0107H26.1782V58.5269Z",
    fill: "#4C458E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 75.6804H10.6981V74.6045H0V75.6804Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1763 75.6804H23.8745V74.6045H13.1763V75.6804Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 78.0682H14.8371V76.9922H0V78.0682Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7324 39.7432C70.7324 39.7432 71.5255 42.1702 71.4574 42.7251C71.3891 43.2801 70.8913 45.1767 70.5356 45.6621C70.18 46.1477 70.0046 43.6851 69.7231 43.3146C69.4417 42.944 69.6654 44.2418 69.4668 44.3619C69.2683 44.482 68.8548 43.4073 68.6769 43.0282C68.499 42.649 69.1118 41.2508 69.1135 40.2764C69.1151 39.302 70.7324 39.7432 70.7324 39.7432Z",
    fill: "#F2B68D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0816 20.4649C51.8619 17.6819 54.9041 15.774 57.3062 17.2213C57.3555 17.251 57.4043 17.2813 57.4526 17.3122C61.049 19.6123 68.809 30.3453 69.3427 31.4205C69.8764 32.4956 71.4531 41.0494 71.4531 41.0494C71.4531 41.0494 69.5051 41.7575 68.5944 41.0228C68.5944 41.0228 65.435 32.9107 64.968 32.5053C64.501 32.0998 52.3322 25.315 52.2286 22.7715C52.2011 22.0989 52.1468 21.2904 52.0816 20.4649Z",
    fill: "#8883B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0425 15.9756L37.1004 18.9947L21.8166 24.2823L20.7588 21.2632L36.0425 15.9756Z",
    fill: "#ED985F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7344 24.0025L21.8165 24.2827L20.7587 21.2637L17.7344 24.0025Z",
    fill: "#F9DDBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1702 16.3625L38.5045 17.317C38.7103 17.9041 38.3981 18.5458 37.8073 18.7502L37.1002 18.9947L36.0425 15.9756L36.8113 15.7097C37.368 15.517 37.9763 15.8094 38.1702 16.3625Z",
    fill: "#F9DDBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7965 83.2869C73.7965 83.2869 75.2465 84.6019 74.9635 85.5361C74.6807 86.4704 73.3721 87.0933 73.1953 88.2352C73.0185 89.3771 72.3111 89.9998 71.6746 89.9998H68.6396C68.6396 89.9998 68.171 89.1963 69.3027 88.9541C70.4344 88.7119 70.8611 87.37 70.7903 86.1244C70.7197 84.8787 70.8964 83.2177 70.8964 83.2177L73.3014 82.6641L73.7965 83.2869Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0075 86.6874C56.0075 86.6874 56.2677 89.6799 55.6312 89.9913L47.4844 89.9747C47.4844 89.9747 47.4844 89.0404 48.793 88.8328C50.1015 88.6252 52.4003 87.8639 52.7893 86.1685C53.1783 84.4728 56.0075 86.6874 56.0075 86.6874Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1289 44.4171C49.1289 44.4171 49.5587 49.6625 50.0637 55.9678C50.7502 64.5331 51.5756 75.054 51.6572 77.0471C51.7983 80.5081 52.3649 86.0442 52.3649 86.0442C52.3649 86.0442 53.7082 87.3595 56.3967 86.805C56.3967 86.805 58.7923 78.9021 59.4767 70.5405C59.4873 70.4034 59.4979 70.2653 59.5085 70.1272C60.1451 61.6149 61.1349 43.6904 61.1349 43.6904L49.1289 44.4171Z",
    fill: "#5B568C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1289 44.4171C49.1289 44.4171 49.5587 49.6625 50.0637 55.9678L59.4767 70.5405C59.4873 70.4034 59.4979 70.2653 59.5085 70.1272C60.1451 61.6149 61.1349 43.6904 61.1349 43.6904L49.1289 44.4171Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0913 45.0399C51.0913 45.0399 58.8364 64.0369 63.929 72.9644C69.0218 81.8919 70.6133 84.3833 70.6133 84.3833C70.6133 84.3833 73.5309 83.2413 73.7961 82.4629C73.7961 82.4629 71.8487 65.2279 68.4382 61.0265C66.5112 58.6523 64.2474 51.528 64.1413 49.0366C64.0351 46.5452 63.4517 41.6143 63.4517 41.6143L51.0913 45.0399Z",
    fill: "#5B568C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.77 16.5437C57.77 16.5437 52.5807 19.159 49.5415 18.2865C49.5415 18.2865 50.2664 17.3398 51.5537 16.6207C51.4372 16.0203 51.3453 15.4991 51.2901 15.0567C51.1418 14.0362 51.1303 13.4564 51.1303 13.4564L53.1202 11.8368L55.0068 10.2871C54.9407 14.5413 57.77 16.5437 57.77 16.5437Z",
    fill: "#F2B68D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9243 43.1173C60.8292 44.3774 58.8457 45.3247 56.5244 45.8569C53.7863 46.502 50.4212 46.3117 49.2952 46.4822C49.1794 46.4979 49.07 46.4675 48.9669 46.3996C48.8785 46.3546 48.3819 43.0359 47.8842 38.8471C47.862 38.6788 47.8388 38.5083 47.8294 38.3379L47.822 38.2814C47.6284 36.6439 47.459 34.924 47.3117 33.1997C47.1917 31.8582 47.0928 30.5312 47.0244 29.285C46.938 27.726 46.9024 26.2934 46.938 25.115C46.9539 24.5765 46.9855 24.0923 47.0339 23.6721C47.3306 21.2253 48.505 19.4771 49.6109 18.1753L50.5285 17.1379C51.5923 17.2049 52.6783 17.0052 53.7032 16.3329C54.8239 15.5999 56.0329 14.8115 56.2613 14.9432C57.9785 15.877 59.377 18.2966 60.3757 21.4919C60.9482 23.3312 61.388 25.4183 61.669 27.6287C61.7595 28.3146 61.8362 29.0183 61.8952 29.7189C61.9067 29.8486 61.9162 29.9782 61.9267 30.1057C62.0614 32.0214 62.2813 33.8165 62.5255 35.4195C62.8537 37.5819 63.2274 39.3929 63.4915 40.6685C63.624 41.3179 63.7251 41.8197 63.7851 42.1795C63.8387 42.4932 63.2063 42.9427 62.9243 43.1173Z",
    fill: "#8883B1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0742 11.9121C55.0742 11.9121 53.7977 14.3366 51.2901 15.0568C51.1419 14.0364 51.1304 13.4567 51.1304 13.4567L53.1202 11.8369L55.0742 11.9121Z",
    fill: "#ED985F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2068 13.4048C50.2068 13.4048 55.2213 14.1186 55.6294 11.0561C56.0377 7.99366 56.9598 6.02327 53.7755 5.43793C50.5912 4.85267 49.8121 5.94209 49.4217 6.93205C49.0315 7.92192 48.9129 13.1401 50.2068 13.4048Z",
    fill: "#F2B68D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3263 5.00266C57.3708 4.95007 57.4744 4.90632 57.7071 4.88916C57.7071 4.88916 57.5187 4.77714 57.2697 4.77592C57.2145 4.45501 57.0308 3.8889 56.4707 3.76136C56.4707 3.76136 56.7733 3.91411 56.8194 4.25547C56.1607 3.60939 54.7677 3.15713 50.9432 3.53306C45.9027 4.02856 47.6307 7.2075 48.2919 7.57754C48.9532 7.9475 50.5773 6.86544 51.7969 6.93744C53.0164 7.00944 53.283 8.75334 53.7008 8.98511C54.1186 9.21687 53.9478 8.7958 54.5018 8.53379C55.0555 8.27171 55.127 9.19096 54.9777 9.79251C54.8281 10.3941 55.6119 11.1681 55.6119 11.1681L56.3713 10.3223C57.1308 9.47653 57.792 5.94445 57.4242 5.20159C57.3917 5.136 57.3595 5.06946 57.3263 5.00266Z",
    fill: "#4C458E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7341 25.3881C55.7341 25.3881 51.5061 28.5845 47.0244 29.2851C46.938 27.7261 46.9024 26.2935 46.938 25.1152L55.7341 25.3881Z",
    fill: "#6B6692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7694 21.2634C29.7027 21.1923 28.8407 18.3284 27.35 18.5373C26.3773 18.6736 24.7873 19.2331 25.2095 20.5065C25.3755 21.0074 28.3394 22.732 28.3394 22.732L29.7694 21.2634Z",
    fill: "#F2B68D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2567 19.2119C58.6674 20.6451 58.4719 24.2144 55.8936 25.3228C55.8407 25.3455 55.7876 25.3675 55.7342 25.3887C51.7648 26.971 38.4651 27.0447 37.2738 26.8546C36.0826 26.6647 28.1509 22.9902 28.1509 22.9902C28.1509 22.9902 28.6975 21.0019 29.8277 20.6893C29.8277 20.6893 38.3132 22.8259 38.9163 22.6823C39.5195 22.5387 52.1316 16.6071 54.2788 17.9956C54.8466 18.3628 55.5415 18.7868 56.2567 19.2119Z",
    fill: "#8883B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreYouDone);
export default ForwardRef;